export const TOAST_KIND = {
    SUCCESS: 'success',
    ERROR: 'error',
} as const;

export type ToastKind = (typeof TOAST_KIND)[keyof typeof TOAST_KIND];

export interface Toast {
    id: string;
    kind: ToastKind;
    message: string;
    durationMs?: number;
}
